<div class="top-background"
  [class.show]="firstImgAndTextWidgets?.length"
  [class.preview]="forPreview"
  #topBackground
  [ngStyle]="dynamicOrStoredAppearance?.topBgConfig"
>
</div>
<ng-container *ngIf="biolink">
  <div class="content"
    [class.padding-top-bottom]="dynamicOrStoredAppearance?.layoutConfig?.configId === 'classic' || !firstImgAndTextWidgets?.length"
  >
    <div class="img-text-widgets"
      *ngIf="firstImgAndTextWidgets.length"
    >
      <ng-container *ngFor="let item of firstImgAndTextWidgets; let i = index">
        <ng-container *ngIf="item.active">
          <ng-container [ngSwitch]="item.type">
            <div
              class="widget image-widget"
              [ngClass]="item.config.type"
              *ngSwitchCase="'image'"
            >
              <a [href]="item.config.destinationUrl" target="_blank">
                <image-or-icon
                  [src]="item.config.url"
                  class="inherit-size"
                ></image-or-icon>
              </a>
            </div>
            <div
              class="widget text-widget"
              *ngSwitchCase="'text'"
              [style.color]="dynamicOrStoredAppearance?.titleConfig?.color || 'inherit'"
            >
              <h2 class="title"
                [ngStyle]="{ 'font-family': dynamicOrStoredAppearance?.fontConfig?.family || 'inherit' }"
              >
                {{ item.config.title }}
                <ng-container
                  *ngIf="showBlueTick.getValue() && i === 1"
                >
                  <span class="blue-tick">
                    <!-- <mat-icon svgIcon="bluetick"></mat-icon> -->
                    <img src="/assets/images/bluetick.png" alt="bluetick" 
                      (mouseover)="showVerifiedDiv = true"
                      (mouseout)="showVerifiedDiv = false"
                    />
                    <!-- <svg width="18" height="22" viewBox="0 0 100 100">
                      <path
                        id="Path_683"
                        data-name="Path 683"
                        d="M204,84a50,50,0,1,0,50,50A50,50,0,0,0,204,84Zm21.562,41.268-27.7,27.7a4.538,4.538,0,0,1-1.473.983,4.463,4.463,0,0,1-4.839-.983l-13.92-13.92a4.463,4.463,0,0,1,6.313-6.312L194.715,143.5l24.545-24.545a4.463,4.463,0,0,1,6.312,6.313Z"
                        transform="translate(-154 -76)"
                        fill="#0040fd"
                      />
                    </svg> -->
                  </span>
                  <div class="verified"
                    [style]="showVerifiedDiv ? 'display: block' : 'display: none'"
                  >
                    <h4>Verified Account</h4>
                    <p>
                      <img src="/assets/images/bluetick.png" alt="bluetick" 
                        matTooltip="Verified Account &#13; This account is verified"
                      />
                      This account is verified.
                    </p>
                  </div>
                </ng-container>
              </h2>
              <p class="description" 
                *ngIf="item.config.description"
                [ngStyle]="{ 'font-family': dynamicOrStoredAppearance?.fontConfig?.family || 'inherit' }"
              >
                {{ item.config.description }}
              </p>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
    <ng-container *ngFor="let item of otherWidgets; let i = index">
      <ng-container *ngIf="item.active">
        <biolink-page-button
          *ngIf="item.model_type === 'link'"
          [link]="item"
          [style]="dynamicOrStoredAppearance?.btnConfig || ''"
        ></biolink-page-button>

        <ng-container [ngSwitch]="item.type">
          <div class="widget socials-widget" *ngSwitchCase="'upi'">
            <upi-button
              [style]="dynamicOrStoredAppearance?.btnConfig || ''"
              [config]="item.config"
            ></upi-button>
          </div>

          <div class="widget socials-widget" *ngSwitchCase="'socials'"
            [style.color]="dynamicOrStoredAppearance?.titleConfig?.color || 'inherit'"
          >
            <social-button-list 
              *ngIf="!hasSubscribedToPaidPlan.getValue() && dynamicOrStoredAppearance?.socialIconConfig?.color === 'colorful'; else showRealIconColor"
              iconColor="black"
              [config]="item.config"
            ></social-button-list>

            <ng-template #showRealIconColor>

              <social-button-list 
                [iconColor]="dynamicOrStoredAppearance?.socialIconConfig?.color || 'black'"
                [config]="item.config"
              ></social-button-list>

            </ng-template>
          </div>
          <div
            class="widget image-widget"
            [ngClass]="item.config.type"
            *ngSwitchCase="'image'"
          >
            <a [href]="item.config.destinationUrl" target="_blank">
              <image-or-icon
                [src]="item.config.url"
                class="inherit-size"
              ></image-or-icon>
            </a>
          </div>
          <div
            class="widget text-widget"
            *ngSwitchCase="'text'"
            [style.color]="dynamicOrStoredAppearance?.titleConfig?.color"
          >
            <h2 class="title"
              [ngStyle]="{ 'font-family': dynamicOrStoredAppearance?.fontConfig?.family || 'inherit' }"
            >
              {{ item.config.title }}
              <!-- if text widget is has index 1 -->
              <ng-container
                *ngIf="showBlueTick.getValue() && i === 1"
              >
                <span class="blue-tick">
                  <!-- <mat-icon svgIcon="bluetick"></mat-icon> -->
                  <img src="/assets/images/bluetick.png" alt="bluetick"
                    (mouseover)="showVerifiedDiv = true"
                    (mouseout)="showVerifiedDiv = false"
                  >
                  <!-- <svg width="18" height="22" viewBox="0 0 100 100">
                    <path
                      id="Path_683"
                      data-name="Path 683"
                      d="M204,84a50,50,0,1,0,50,50A50,50,0,0,0,204,84Zm21.562,41.268-27.7,27.7a4.538,4.538,0,0,1-1.473.983,4.463,4.463,0,0,1-4.839-.983l-13.92-13.92a4.463,4.463,0,0,1,6.313-6.312L194.715,143.5l24.545-24.545a4.463,4.463,0,0,1,6.312,6.313Z"
                      transform="translate(-154 -76)"
                      fill="#0040fd"
                    />
                  </svg> -->
                </span>
                <div class="verified"
                  [style]="showVerifiedDiv ? 'display: block' : 'display: none'"
                >
                  <h4>Verified Account</h4>
                  <p>
                    <img src="/assets/images/bluetick.png" alt="bluetick" 
                      matTooltip="Verified Account &#13; This account is verified"
                    />
                    This account is verified.
                  </p>
                </div>
              </ng-container>
            </h2>
            <p class="description" 
              *ngIf="item.config.description"
              [ngStyle]="{ 'font-family': dynamicOrStoredAppearance?.fontConfig?.family || 'inherit' }"
            >
              {{ item.config.description }}
            </p>
          </div>
          <div class="widget youtube-embed" *ngSwitchCase="'youtubeEmbed'">
            <iframe
              [src]="
                trustUrl(
                  'https://www.youtube.com/embed/' +
                    getVimeoEmbedId(item.config.url)
                )
              "
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div
            class="widget soundcloud-embed"
            *ngSwitchCase="'soundcloudEmbed'"
            [innerHTML]="trustHtml(item.config.embedCode)"
          ></div>
          <div class="widget youtube-embed" *ngSwitchCase="'vimeoEmbed'">
            <iframe
              [src]="
                trustUrl(
                  'https://player.vimeo.com/video/' +
                    getVimeoEmbedId(item.config.url)
                )
              "
              allow="autoplay; fullscreen; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div class="widget spotify-embed" *ngSwitchCase="'spotifyEmbed'">
            <iframe
              [src]="getSpotifyEmbedUrl(item.config.url)"
              allow="autoplay; fullscreen; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div class="widget twitch-embed" *ngSwitchCase="'twitchEmbed'">
            <iframe
              [src]="getTwitchEmbedUrl(item.config.url)"
              allow="autoplay; fullscreen; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
          <div class="widget" *ngSwitchCase="'tiktokEmbed'">
            <blockquote
              [attr.data-video-id]="getTiktokVideoId(item.config.url)"
              class="tiktok-embed"
            >
              <section>
                <img
                  [src]="settings.getAssetUrl('widgets/tiktok.png')"
                  alt=""
                />
              </section>
            </blockquote>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
